import { licenses } from 'locales/ja/licenses';
import type { PageType } from 'types/page_type';

export const expiredPage: Readonly<PageType> = {
  path: '/expired',
  title: `${licenses.resourceName}有効期間外`,
  description: `${licenses.resourceName}が有効期間外のため、アクセスできません。`,
};
